import { Component, OnInit, EventEmitter, Input } from '@angular/core';
import { IServiceFactory } from '../../Services/service-factory';
import { FilterService } from '../../Services/filter-service';
import { MatRadioChange } from '@angular/material/radio';
import { StudentFilterValues, ELearningDashboardState } from '../../Elearning-Models';
import { ElearningdashStudentViewComponent } from '../elearningdash-student-view/elearningdash-student-view.component';
import { IStateService } from '../../Services/state-service';


@Component({
  selector: 'app-student-filter',
  templateUrl: './student-filter.component.html',
  styleUrls: ['./student-filter.component.scss']
})
export class StudentFilterComponent implements OnInit {

  filterService: FilterService;
  stateService: IStateService;

  state: ELearningDashboardState = new ELearningDashboardState();
  constructor(private serviceFactory: IServiceFactory) { 
  }

  ngOnInit(): void {
    this.filterService = this.serviceFactory.getFilterService();
    this.setStateService();
    this.chooseFilter(this.state.StudentFilter);
  }

  private setStateService() {
    this.stateService = this.serviceFactory.getStateService();
    this.stateService.stateEmitter.subscribe(result=>{
      if(result){
        this.state.copyFromModel(result);
      }
    });    
  }

  showAllStudents(){
    this.filterService.emitAllStudents();
  }

  showAllStudentsWithActionItems(){
    this.filterService.emitStudentsWithActionItems();
  }

  hideAllStudents(){
    this.filterService.emitNoStudents();
  }

  filterStudents(event: MatRadioChange){
    this.chooseFilter(event.value);
  }

  private chooseFilter(filter: number) {
    this.stateService.setState(filter);
    switch (filter) {
      case StudentFilterValues.All:
        this.showAllStudents();
        
        break;
      case StudentFilterValues.NeedsAttention:
        this.showAllStudentsWithActionItems();
        break;
    }
  }

  getCheckedValue(value: number){
    
    if(!this.state.StudentFilter){
      // if filter state is null -> then use needs attention
      if(value == StudentFilterValues.All){
        return false;
      }
      else{
        return true;
      }
    }
    else{
      return value == this.state.StudentFilter;
    }
  }

}
